import { useEffect } from 'react'
import { useSelector } from 'react-redux'
import { usePostHog } from '@posthog/react'

import { userUidSelector } from '../global/state/userUidSelector'

function PostHogIdentify() {
    const posthog = usePostHog()
    const userUid = useSelector(userUidSelector)
    const config = useSelector((state) => state.config)
    const userInfo = useSelector((state) => state.userInfoJson)

    useEffect(() => {
        if (!posthog) {
            return
        }

        const properties = {
            environment: process.env.REACT_APP_ENVIRONMENT,
        }

        if (config?.customer) {
            properties.customer = config.customer
        }

        posthog.register(properties)
    }, [posthog, config?.customer])

    useEffect(() => {
        if (!posthog) {
            return
        }

        if (userUid) {
            posthog.identify(userUid, {
                email: userInfo?.email || undefined,
                name: userInfo?.displayName || undefined,
            })
        } else {
            posthog.reset()
        }
    }, [posthog, userUid, userInfo?.email, userInfo?.displayName])

    return null
}

export default PostHogIdentify
